// extracted by mini-css-extract-plugin
export var fullvideo = "backgroundVideo-module--fullvideo--70338";
export var wrapper = "backgroundVideo-module--wrapper--e4f6f";